// extracted by mini-css-extract-plugin
export default {"loader-container":"styles_loader-container__TMAg3"};